import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  "data-aos": "fade-up",
  class: "container justify-content-center"
}
const _hoisted_2 = { class: "col-md-6" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "description" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  key: 1,
  class: "d-flex flex-row gap-2 mt-3"
}
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "tech-stack" }

import {ref, watch} from 'vue';
import CardImage from './CardImage.vue';
import {useStore} from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectCard',
  props: {
    title: {},
    description: {},
    links: {},
    buttons: {},
    techStack: {},
    imageSource: {},
    showImageRight: { type: Boolean },
    isSmallImage: { type: Boolean },
    isLargeImage: { type: Boolean }
  },
  setup(__props: any) {



const store = useStore();
const isDarkMode = ref(store.state.isDarkMode);

watch(
  () => store.state.isDarkMode,
  newValue => {
    isDarkMode.value = newValue;
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["card col-xl-8", {
        'card-dark': isDarkMode.value,
        'card-light': !isDarkMode.value,
        'card-left-padding': !__props.showImageRight,
      }])
    }, [
      (!__props.showImageRight)
        ? (_openBlock(), _createBlock(CardImage, {
            key: 0,
            "is-right": __props.showImageRight,
            "image-source": __props.imageSource,
            "is-small-image": __props.isSmallImage,
            "is-large-image": __props.isLargeImage
          }, null, 8, ["is-right", "image-source", "is-small-image", "is-large-image"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(__props.title), 1),
        _createElementVNode("p", _hoisted_4, _toDisplayString(__props.description), 1),
        (__props.links)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.links, (link, index) => {
                return (_openBlock(), _createElementBlock("a", {
                  key: index,
                  href: link,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  class: "link no-decorative-link"
                }, _toDisplayString(link), 9, _hoisted_6))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (__props.buttons)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.buttons, (button, index) => {
                return (_openBlock(), _createElementBlock("a", {
                  key: index,
                  href: button.link,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  class: _normalizeClass(["btn btn-custom btn-sm", {
              'btn-outline-dark-custom': isDarkMode.value,
              'btn-outline-light-custom': !isDarkMode.value,
            }])
                }, _toDisplayString(button.text), 11, _hoisted_8))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.techStack, (tech, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createElementVNode("div", {
                class: _normalizeClass(["tech-item", {
                'bg-black': isDarkMode.value,
                'bg-secondary': !isDarkMode.value,
              }])
              }, _toDisplayString(tech), 3)
            ]))
          }), 128))
        ])
      ]),
      (__props.showImageRight)
        ? (_openBlock(), _createBlock(CardImage, {
            key: 1,
            "is-right": __props.showImageRight,
            "image-source": __props.imageSource,
            "is-small-image": __props.isSmallImage,
            "is-large-image": __props.isLargeImage
          }, null, 8, ["is-right", "image-source", "is-small-image", "is-large-image"]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})